import { ComponentRef } from '@wix/editor-platform-sdk-types';
import {
  IHostType,
  definePlatformAPI,
  ConsumerTypes,
  ApiVersions,
} from '../../common';
import { ISuperAPI } from './refComponents.super';
import {
  IHiddenComponentOptions,
  IRole,
  ISelector,
} from './refComponents.types';
import { CompRef } from '@wix/document-services-types';

export type IPlatformAPIDefinition = {
  consumerType: typeof ConsumerTypes.PanelBuilder;
  version: typeof ApiVersions.V2;
  hostType: IHostType;
  superAPI: ISuperAPI;
  platformAPI: {
    refComponents: {
      hide(widgetRef: ComponentRef, selector: ISelector): Promise<void>;
      show(widgetRef: ComponentRef, selector: ISelector): Promise<void>;
      isHidden(widgetRef: ComponentRef, selector: ISelector): Promise<boolean>;
      getHiddenComponentRoles(
        widgetRef: ComponentRef,
        options?: IHiddenComponentOptions,
      ): Promise<IRole[]>;
      findComponentBySelector(
        widgetRef: ComponentRef,
        selector: ISelector,
      ): CompRef;
    };
  };
};

export const platformAPICreator = definePlatformAPI<IPlatformAPIDefinition>(
  (superAPI) => {
    // @ts-expect-error
    return (context) => {
      return {
        refComponents: {
          show: (widgetRef: ComponentRef, selector: ISelector) =>
            superAPI.refComponents.showBySelector(widgetRef, selector),
          hide: (widgetRef: ComponentRef, selector: ISelector) =>
            superAPI.refComponents.hideBySelector(widgetRef, selector),
          isHidden: (widgetRef: ComponentRef, selector: ISelector) =>
            superAPI.refComponents.isHiddenBySelector(widgetRef, selector),
          getHiddenComponentRoles: (
            widgetRef: ComponentRef,
            options?: IHiddenComponentOptions,
          ) =>
            superAPI.refComponents.getHiddenComponentRoles(widgetRef, options),
          findComponentBySelector: (
            widgetRef: ComponentRef,
            selector: ISelector,
          ) =>
            superAPI.refComponents.findComponentBySelector(widgetRef, selector),
        },
      };
    };
  },
);
